// Shared constants + helpers for the CivilSearch Missive email path (GT-374).

export const MISSIVE_TOKEN_STORAGE_KEY = 'missiveApiToken';

export const MISSIVE_WEB_BASE = 'https://mail.missiveapp.com';

/** One-time-setup guide: how to find your Missive personal access token. */
export const MISSIVE_USER_GUIDE_URL =
  'https://app.notion.com/p/civilgrid/Missive-User-Guide-38f81357ce6980359d9eede96aba8b83?source=copy_link#39981357ce6980408286cef4123c1eda';

export const MISSIVE_TOKEN_PREFIX = 'missive_pat';

export function isValidMissiveToken(token: string): boolean {
  return token.trim().startsWith(MISSIVE_TOKEN_PREFIX);
}

export function getMissiveToken(): string | null {
  return window.localStorage.getItem(MISSIVE_TOKEN_STORAGE_KEY);
}

export function saveMissiveToken(token: string): void {
  window.localStorage.setItem(MISSIVE_TOKEN_STORAGE_KEY, token.trim());
}

export const missiveSearchUrl = (query: string): string => `${MISSIVE_WEB_BASE}/#search/${encodeURIComponent(query)}`;

/** No PAT / API call — works whenever the user is logged into Missive in their browser. */
export function searchRelatedMissiveEmail(requestId: string): void {
  window.open(missiveSearchUrl(requestId), '_blank', 'noopener,noreferrer');
}
